import { lazy } from 'react';

import usePdfDowVolume from './usePdfDowVolume';

const DowVolumes = lazy(() => import('./DowVolumes'));
const DowVolumesGraph = lazy(() => import('./DowVolumesGraph'));

export { DowVolumes, DowVolumesGraph, usePdfDowVolume };
